/**
 * Тихие часы хранятся минутами от полуночи, а показываются часами (тикет T18b, § 14.2).
 *
 * Отдельным файлом, потому что здесь ошибаются: в полуночи, в однозначных минутах и в
 * значении, пришедшем не числом. Ошибка тут тихая — человек выставит «22:00», а замолчим
 * мы в 02:20, и связать одно с другим он не сможет.
 */

const MINUTES_IN_DAY = 24 * 60;

const pad = (value: number): string => String(value).padStart(2, '0');

/** Минуты от полуночи → «22:00». Часы всегда двузначные: `2:0` браузер не примет. */
export const minutesToClock = (minutes: unknown): string => {
  const whole = typeof minutes === 'number' && Number.isSafeInteger(minutes) ? minutes : 0;
  // Значение из более новой версии могло уехать за сутки — сворачиваем в сутки, а не
  // показываем «27:30»: такого времени человек в поле всё равно не увидит.
  const inDay = ((whole % MINUTES_IN_DAY) + MINUTES_IN_DAY) % MINUTES_IN_DAY;
  return `${pad(Math.floor(inDay / 60))}:${pad(inDay % 60)}`;
};

/**
 * «22:00» → минуты от полуночи. Непонятное время — `null`, и тогда правку не отправляют:
 * записать вместо него полночь значило бы молча выставить человеку не то, что он набрал.
 */
export const clockToMinutes = (clock: string): number | null => {
  const found = /^(\d{1,2}):(\d{2})$/.exec(clock.trim());
  if (!found) return null;
  const hours = Number(found[1]);
  const minutes = Number(found[2]);
  if (hours > 23 || minutes > 59) return null;
  return hours * 60 + minutes;
};
